import { createSlice } from "@reduxjs/toolkit";

const globalSlice = createSlice({
  name: "global",
  initialState: {
    unread: null,
  },
  reducers: {
    setUnread: (state, action) => {
      console.log(
        "%c[REDUX] setUnread",
        "color: blue",
        "payload:",
        action.payload,
        "BEFORE:",
        state.unread
      );

      state.unread = Math.max(0, action.payload ?? 0);

      console.log(
        "%c[REDUX] setUnread AFTER",
        "color: blue",
        "unread:",
        state.unread
      );
    },

    applyUnreadDelta: (state, action) => {
      console.log(
        "%c[REDUX] applyUnreadDelta",
        "color: green",
        "delta:",
        action.payload,
        "BEFORE:",
        state.unread
      );

      state.unread = Math.max(0, state.unread + (action.payload ?? 0));

      console.log(
        "%c[REDUX] applyUnreadDelta AFTER",
        "color: green",
        "unread:",
        state.unread
      );
    },

    resetUnread: (state) => {
      console.log("%c[REDUX] resetUnread", "color: orange");
      state.unread = 0;
    },
  },
});

export const { setUnread, applyUnreadDelta, resetUnread } =
  globalSlice.actions;

export default globalSlice.reducer;
